module.exports = __webpack_public_path__ + "static/img/yichu2.99bef32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yichu2.png
// module id = yIys
// module chunks = 24